/**
 * Processes CSV data to extract headers and the number of rows.
 *
 * @param {String} csvText - The CSV data as a string.
 * @param {Number} [headerRow=0] - The row index for the headers.
 * @param {String} [separator=','] - The separator used in the CSV file.
 * @param {Boolean} [hasHeaders=true] - Indicates if the CSV has headers.
 * @return {Object} An object containing the headers and the number of rows.
 */
const processCSV = ( csvText, headerRow = 0, separator = ',', hasHeaders = true ) => {
	const rows = csvText.split( '\n' ).filter( row => row.trim() !== '' );
	let headers;
	let numberOfRows;

	if ( hasHeaders ) {
		headers = rows[headerRow].split( separator );
		numberOfRows = rows.length - 1; // Subtract one for the header row
	} else {
		headers = rows[0].split( separator ).map( ( _, index ) => `Column${index + 1}` );
		numberOfRows = rows.length;
	}

	return {
		type: 'csv',
		headers: headers,
		numberOfRows: numberOfRows
	};
}

export default processCSV;
